import socket from '@/plugins/socket'

export default {
  namespaced: true,
  state: {
    list: []
  },
  mutations: {
    init: (state, datas) => { state.list = datas }
  },
  actions: {
    init (state) { socket.get('SportSportScorediscipline', 'Sport/ScoreDiscipline/init') }
  },
  getters: {
    get: (state) => (disciplineId) => {
      return state.list.filter((item) => item.disciplineId === disciplineId).sort((a, b) => a.order - b.order)
    }
  }
}
